const data = {
  "includedByDefault": {
    "manual": "Handleiding"
  },
  "collectionDropdown": {
    "chooseAnOption": "Kies een optie",
    "recommended": "Aanbevolen"
  },
  "topNavigation": {
    "homepage": "Coolblue homepage",
    "navigation": "Hoofdnavigatie"
  },
  "explanationIcon": {
    "label": "Uitleg"
  },
  "colorPicker": {
    "chooseAnotherColor": "Kies een andere kleur",
    "color": "Kleur"
  },
  "productPlus": {
    "added": "Toegevoegd",
    "salesPricePrefix": "t.w.v.",
    "consentRequired": "Je moet akkoord gaan met de voorwaarden om verder te gaan.",
    "cancel": "Annuleren",
    "specialOffer": "Speciale aanbieding",
    "chooseSpecialOffer": "Kies je speciale aanbieding"
  },
  "usbCChargerIncluded": {
    "included": "Oplader meegeleverd",
    "notIncluded": "Geen oplader meegeleverd"
  },
  "navigationMenu": {
    "myCoolblue": "Mijn Coolblue",
    "accountOverview": "Overzicht van {{accountName}}",
    "accountOverviewWithoutName": "Overzicht",
    "ordersOverview": "Bestellingen",
    "ordersAndInvoices": "Bestellingen en facturen",
    "returnsAndRepairsOverview": "Retouren en reparaties",
    "informationAndPreferences": "Gegevens en voorkeuren",
    "credits": "Tegoeden",
    "discounts": "Kortingen",
    "wishlist": "Verlanglijstje",
    "coolblueEnergy": "Coolblue Energie",
    "logOut": "Uitloggen"
  },
  "chatbotEntrance": {
    "title": "Wil je contact opnemen?",
    "description": "Stel je vraag aan onze digitale assistent en hij koppelt je aan de juiste specialist.",
    "makeContact": "Neem contact met ons op"
  }
};

export default data;